import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-guest-counter-modal',
  templateUrl: './guest-counter-modal.component.html',
  styleUrls: ['./guest-counter-modal.component.scss'],
})
export class GuestCounterModalComponent {
  @Input() adult = 1;
  @Input() child = 0;
  @Input() infant = 0;
  @Input() isSafeArea = false;

  public currentHeaderData: any = {
    title: 'modals.guest_count_modal.select_passenger',
    marl20: true,
    modalSlotEnd: true,
  };

  ngOnInit() { 
    this.currentHeaderData.isSafeArea = this.isSafeArea;
  }

  constructor(private modalController: ModalController, private analyticsService: AnalyticsService) {}

  increment(type: 'adult' | 'child' | 'infant') {
    const next = this[type] + 1;
    this[type] = Math.min(9, next);
  }

  decrement(type: 'adult' | 'child' | 'infant') {
    const next = this[type] - 1;
    if (type === 'adult') {
      this.adult = Math.max(1, next);
    } else {
      this[type] = Math.max(0, next);
    }
  }

  confirm() {
    this.modalController.dismiss({ adult: this.adult, child: this.child, infant: this.infant });
  }

  closeModal() {
    this.analyticsService.trackUnified('guest_counter_modal_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Guest Counter Modal Closed',
      component: 'guest-counter-modal',
    });
    this.modalController.dismiss();
  }
}

